import React, { useState, useEffect } from 'react';

import { Header, Footer, HeaderBox, BlogArticle } from '../../components/imports'

import { APP_NAME } from '../../constants/general'

import Fetch from '../../class/Fetch';

const getArticles = async (setArticles) => {

    window.scrollTo(0, 0)

    let results = await Fetch.get('blog/get')

    setArticles(results.data)

}

function Blog() {

    const [articles, setArticles] = useState(false)

    useEffect(() => {

        getArticles(setArticles)

        document.title = "Le journal de Lylie - Blog - " + APP_NAME

    }, [])


    return (
        <div>

            <Header />

            <div>

            <HeaderBox />

                <div className="c1 m_p10 m_mt_40 m_mb_40">

                    <div className='c pt100 pb20 m_mb_40 ta-center'>
                        <h1>Le journal de Lylie</h1>
                    </div>

                    <div className="c pt80 pb40">

                            {

                                articles

                                ?

                                    <div className="grid3 articles">

                                        { articles.map(element => <BlogArticle data={element} key={element.idA} />)}
                                        
                                    </div>

                                :

                                    <div className='flex jc-center mt50 mb50'>
                                        <div className="lds-dual-ring col"></div>
                                    </div>

                            }

                    </div>

                </div>

            </div>

            <Footer />

        </div>
    )

}

export default Blog